import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()

export class Globals {
    hideGlobalLoaderFlag: boolean = false;
    showLayover = new Subject<boolean>();
}   